import { defineStore } from 'pinia';
import {
  DEFAULT_PAYOUT_ORDER_LIST_FILTER_FORM_DATA,
} from '@/constants/payout-order/payout-order-list-filter.constant';
import { PayoutOrderListFilterFormData } from '@/models/payout-order/payout-order-list-filter.model';
import { ref } from 'vue';
import { FormInstance } from 'element-plus';
import { tagListToTagIdList } from '@/mappers/dictionary/tag-list-to-tag-id-list.mapper';
import { segmentListToSegmentIdList } from '@/mappers/dictionary/segment-list-to-segment-id-list.mapper';

interface PayoutOrderListFilterState {
  payoutOrderListFilterFormData: PayoutOrderListFilterFormData;
}

export const payoutOrderListFilterFormRef = ref<FormInstance>();

export const usePayoutOrderListFilterStore = defineStore('PayoutOrderListFilter', {
  state: (): PayoutOrderListFilterState => ({
    payoutOrderListFilterFormData: structuredClone(DEFAULT_PAYOUT_ORDER_LIST_FILTER_FORM_DATA),
  }),
  getters: {
    isFilterTagIdListNotEmpty(state: PayoutOrderListFilterState): boolean {
      return (state.payoutOrderListFilterFormData.tagList ?? []).length > 0;
    },
    isFilterSegmentIdListNotEmpty(state: PayoutOrderListFilterState): boolean {
      return (state.payoutOrderListFilterFormData.segmentList ?? []).length > 0;
    },
    filterTagIdList(state: PayoutOrderListFilterState): string[] {
      return tagListToTagIdList(state.payoutOrderListFilterFormData.tagList);
    },
    filterSegmentIdList(state: PayoutOrderListFilterState): string[] {
      return segmentListToSegmentIdList(state.payoutOrderListFilterFormData.segmentList);
    },
    isFilterPaymentSystemListNotEmpty(state: PayoutOrderListFilterState): boolean {
      return (state.payoutOrderListFilterFormData.paymentSystemList ?? []).length > 0;
    },
    isFilterCountryListNotEmpty(state: PayoutOrderListFilterState): boolean {
      return (state.payoutOrderListFilterFormData.countryList ?? []).length > 0;
    },
  },
  actions: {
    setTagIdListCondition(value: string): void {
      this.payoutOrderListFilterFormData.tagIdListCondition = value;
    },
    setSegmentIdListCondition(value: string): void {
      this.payoutOrderListFilterFormData.segmentIdListCondition = value;
    },
    setPaymentSystemListCondition(value: string): void {
      this.payoutOrderListFilterFormData.paymentSystemListCondition = value;
    },
    setCountryListCondition(value: string): void {
      this.payoutOrderListFilterFormData.countryListCondition = value;
    },
  },
});
